// NPM Imports
import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Button, Input } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// CSS Imports
import signIn from "./signin.module.scss";

// Internal Imports
import { AUTH } from "../../constants";
import { GlobalUtils } from "../../utils";

// Service Imports
import { authEmailLookupService } from "../../AuthService/authService";

// Destructuring
const { writeDataToLocalStorage, validateEmail } = GlobalUtils;
const { GOOGLE_BASED_AUTH, PASSWORD_BASED_AUTH, SAML_BASED_AUTH } = AUTH;

function EmailLookUp(props) {
  // Local States
  const [state, setState] = useState({
    email: "",
    errMsg: "",
    showLoader: false,
  });

  // Local Functions

  const _verifyEmail = () => {
    setState(prev => ({ ...prev, errMsg: "" }));

    if (!state.email) {
      setState(prev => ({ ...prev, errMsg: "Email field is mandatory." }));
    } else if (!validateEmail(state.email)) {
      setState(prev => ({ ...prev, errMsg: "Please enter a valid email." }));
    } else {
      setState(prev => ({ ...prev, showLoader: true }));
      authEmailLookupService(state.email.toLocaleLowerCase())
        .then(response => {
          //  CHECK IF EMAIL REGISTERED IN REVV
          const {
            domains,
            handle,
            invited_domains: invitedDomains,
            suggestion,
          } = response;
          const status = handle && handle.split("")[0];
          if (status === "n") {
            return setState(prev => ({
              ...prev,
              showLoader: false,
              errMsg: "Email does not exist. Please sign up",
            }));
          }

          //  CHECK IF USER ENTERED EMAIL HAS PENDING INVITE

          if (invitedDomains && invitedDomains.length > 0) {
            return props.toggleView({
              currentView: "orgListing",
              domains,
              invitedDomains,
              email: state.email,
              suggestion,
            });
          }

          //  IF THE EMAIL IS ASSOCIATED TO ONLY ONE ORG
          if (domains && domains.length === 1) {
            const signinMethod = domains[0].preference;
            if (domains[0].active) {
              // if the signin method is google based
              if (signinMethod === GOOGLE_BASED_AUTH) {
                props.toggleView({
                  currentView: "google",
                  domains,
                  email: state.email,
                  suggestion,
                  selectedDomain: domains[0].sub_domain,
                });
              }
              // else if the signin method is password based
              else if (signinMethod === PASSWORD_BASED_AUTH) {
                props.toggleView({
                  currentView: "password",
                  domains,
                  email: state.email,
                  suggestion,
                  selectedDomain: domains[0].sub_domain,
                  isVerified: domains[0].is_verified,
                });
              }
              // else if the signin method is SAML based
              else if (signinMethod === SAML_BASED_AUTH) {
                writeDataToLocalStorage("samlLoginOrgId", domains[0].org_id);
                props.toggleView({
                  currentView: "saml",
                  domains,
                  email: state.email,
                  suggestion,
                  selectedDomain: domains[0].sub_domain,
                });
              }
            } else {
              // if the current domain is not active, show the error message
              setState(prev => ({
                ...prev,
                showLoader: false,
                errMsg: "Account is not Active",
              }));
            }
          } else {
            //  IF THE EMAIL IS ASSOCIATED TO MULTIPLE  ORG
            props.toggleView({
              currentView: "orgListing",
              domains,
              email: state.email,
              suggestion,
            });
          }

          return true;
        })
        .catch(error => {
          console.error(`SignIn => EmailLookUp => _verifyEmail => ${error}`);
          setState(prev => ({
            ...prev,
            showLoader: false,
            errMsg: "Something went wrong. Please try again!",
          }));
        });
    }
  };

  const _onEmailInputChange = e => {
    let trimedValue = e.target.value;
    if (trimedValue) {
      trimedValue = trimedValue.trim();
    }
    setState(prev => ({
      ...prev,
      email: trimedValue,
      errMsg: "",
    }));
  };

  const _onEmailInputKeyDown = e => {
    if (e.key === "Enter") {
      _verifyEmail();
    }
  };

  return (
    <Fragment>
      {/** HEADER SECTION */}
      <section>
        <div className={signIn.headerText}>Log into Revv</div>
        {state.errMsg && (
          <div className={signIn.errorMessage}>
            <span className={signIn.errorMessageIcon}>
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </span>
            {state.errMsg}
          </div>
        )}
      </section>

      {/** FORM SECTION */}
      <section>
        <div className={signIn.formSection}>
          <span className={signIn.fieldLabel}> Work Email</span>
          <Input
            data-test="signin-work-email"
            className={signIn.formControl}
            id="signin-email-field"
            type="email"
            placeholder="Enter your work email"
            name="email"
            value={state.email}
            onChange={e => _onEmailInputChange(e)}
            onKeyDown={e => _onEmailInputKeyDown(e)}
            autoFocus
          />
          <Button
            type="four"
            data-test="signin-continue"
            className={signIn.authBtn}
            id="signin-email-continue-btn"
            isLoading={state.showLoader}
            onClick={() => _verifyEmail()}>
            Continue
          </Button>
        </div>
      </section>
    </Fragment>
  );
}

EmailLookUp.defaultProps = {};

EmailLookUp.propTypes = {
  toggleView: PropTypes.func.isRequired,
};

export default EmailLookUp;
